export const QuestRoute = {
    paymentForm: {
        setup: '/payments/hosted-forms',
        exact: '/payments/exact/form_data',
        worldpay: '/payments/worldpay/addnew',
        moneris: '/payments/moneris/setup',
        avsRequired: '/payments/avs-required',
    },
    validate: {
        email: '/users/unique',
    },
    purchase: {
        finalize: '/orders',
        resendOrderEmail: '/users/purchases/resend',
        clubSharedWash: '/orders/cswash/'
    },
    user: {
        login: '/users/login',
        refreshToken: '/users/tokens',
        info: '/users',
        loyaltyPoints: '/users/points',
        notifications: '/users/notifications',
        unreadNotifications: '/users/notifications?status=unread',
        purchaseHistory: '/users/purchases',
        wallet: '/users/wallet',
        awards: '/users/wallet/awards',
        signUp: '/users',
        washClub: '/users/washclub',
        vehicle: '/users/vehicle',
        confirmationEmail: '/users/emails/confirmation',
        confirmedEmail: '/users/emails/confirmed',
        forgotPassword: '/users/emails/forgot-password',
        recoverPassword: '/users/forgot-password',
        updatePassword: '/users/update-password',
        firebaseToken: '/users/firebase',
        deals: '/users/deals',
        delete: '/users',
        locationAssignment: '/users/homeLocation',
        checkChild: (email) => `/users/childcheck/${email}`,
        addChild: '/users/familyPlanInvite',
        confirmFamilyPlan: (token) => '/users/familyPlan/confirm?token=' + token,
        cancelChild: '/users/washclub/cancelChild',
    },
    merchant: {
        processor: '/settings/app/processor/mobile',
        settings: '/user/Settings',
        siteKey: '/accounts/site-key',
        siteConfig: '/accounts/site-config',
        privacyPolicy: '/accounts/settings/app?name=PrivacyPolicy',
        support: '/accounts/settings/app',
        terms: '/accounts/settings/app?name=Terms',
        WCTerms: '/loyalty/settings?name=Terms&category=AppWashClub',
        referralPoints: '/loyalty/settings?name=ReferrerPoints&category=AppReferral',
        states: '/accounts/states',
        subdomain: '/accounts/subdomain',
        p2p: '/settings/p2p',
        features: '/accounts/app-features'
    },
    giftCard: {
        balance: '/gift-cards',
        recharge: '/gift-cards',
    },
    products: {
        washes: '/products?type=AppWash',
        washClubs: '/products?type=AppClub',
        bundles: '/products?type=AppBundle',
        giftCards: '/products?type=giftCard&type=giftCardRecharge&type=AppCredit',
        merchandise: '/products?type=merchandise',
        promoCode: '/promo-codes',
        deals: '/deals',
        time: '/products?type=VacTime&type=BayTime',
    },
    locations: '/locations',
    device: {
        clearId: '/devices'
    },
    survey: {
        questions: {
            leaving: "/survey/leaving",
            merchant: "/survey/merchant"
        },
        submit: "/survey/submit-response"
    },
    tempToken: '/temptoken',
    appVersion: '/system/app-version',
    siteConfig: '/system/site-config',
    buildVersions: '/system/build-versions',
    errorLogging: '/users/errors',
    firebaseUpload: '/accounts/settings/firebase',
    firebaseProjectIds: '/firebase/project-ids',
    imgUpload: '/accounts/upload',
    downloadWrapper: (OS, name) => `/packages/${OS}?name=${name}`,
    targetedNotification: `/notifications/target`,
    LoyaltyPointAwards: '/LoyaltyPointAwards',
}